import { create } from "zustand";

import { TUserAccociatedBU } from "@type/api/businessUnit/types";
import { TBooleanRecord } from "types/index";

export type TBusinessUnit = Omit<
  TUserAccociatedBU,
  "roleName" | "totalMember"
> & {
  slug: string;
};

type TBussinessUnitStore = {
  isLoading: boolean;
  selectedBU?: TBusinessUnit;
  buAccessRight?: TBooleanRecord;
  buAppAccessRight?: TBooleanRecord;
  mapBUList?: Record<string, TBusinessUnit>;
  onSetMapBUList: (mapBUList: Record<string, TBusinessUnit>) => void;
  onSetLoading: (isLoading: boolean) => void;
  onSetSelectedBU: (bu: TBusinessUnit) => void;
  onSetBUAccessRight: (access: TBooleanRecord) => void;
  onSetBUAppAccessRight: (access: TBooleanRecord) => void;
};

export const useBusinessUnitStore = create<TBussinessUnitStore>((set) => ({
  isLoading: true,
  selectedBU: undefined,
  buAccessRight: undefined,
  buAccessAppRight: undefined,
  onSetLoading: (isLoading) => {
    set({ isLoading });
  },
  onSetSelectedBU: (selectedBU) => {
    set({ selectedBU });
  },
  onSetBUAccessRight: (buAccessRight) => {
    set({ buAccessRight });
  },
  onSetMapBUList: (mapBUList) => {
    set({ mapBUList });
  },
  onSetBUAppAccessRight: (buAppAccessRight) => {
    set({ buAppAccessRight });
  },
}));
